Postlogin = (function (self) {
    self.LessonStudentProgress = {};
    const me = self.LessonStudentProgress;
    const studentProgressTable = $('#student-progress-table');
    const exportUrl = $('#export-student-progress-report').data('export-url');

    me.init = function () {
        // load groups for selected license
        $.ajax({
            url: '/groups/select/',
            method: 'post',
            dataType: 'json',
            async: false,
            success({ data }) {
                const myGroups = data.mine;
                const sharedWithMe = data.shared;

                if (myGroups.length) {
                    const optGroup = $('<optgroup label="My Groups"></optgroup>');
                    $.each(myGroups, (i, group) => {
                        optGroup.append($('<option>').val(group.group_id).text(group.name));
                    });
                    $('#user-groups').append(optGroup);
                }

                if (sharedWithMe.length) {
                    const optGroup = $('<optgroup label="Shared With Me"></optgroup>');
                    $.each(sharedWithMe, (i, group) => {
                        optGroup.append(
                            $('<option>')
                                .val(group.group_id)
                                .text(`${group.name} [${group.first_name} ${group.last_name}]`),
                        );
                    });
                    $('#user-groups').append(optGroup);
                }
            },
        });

        // Ported from bootstrap-select to Tom Select 2026-05-11.
        // hide.bs.select → onDropdownClose. The .has-values class was
        // applied to bootstrap-select's .btn-group wrapper; Tom Select
        // renders a .ts-wrapper instead, so we target that.
        const userGroupsEl = document.getElementById('user-groups');
        if (userGroupsEl) {
            // eslint-disable-next-line no-new
            new TomSelect(userGroupsEl, {
                placeholder: 'Choose Group(s)',
                plugins: ['remove_button'],
                diacritics: true,
                maxOptions: null,
                onDropdownClose() {
                    const selectedGroups = $.makeArray(
                        $('#user-groups option:selected').map((a, item) => item.value),
                    );
                    const $wrapper = $('#user-groups').parent().find('.ts-wrapper');
                    if (selectedGroups.length > 0) {
                        $wrapper.addClass('has-values');
                    } else {
                        $wrapper.removeClass('has-values');
                    }
                    studentProgressTable.bootstrapTable('refresh');
                },
            });
        }

        initTimePickers();
        initBootstrapTable();
    };

    const today = new Date();
    const minDate = new Date(today.getFullYear() - 6, today.getMonth(), today.getDate());
    const initTimePickers = function () {
        const dateOptions = {
            display: {
                theme: 'light',
                components: {
                    clock: false,
                },
            },
            localization: {
                format: 'L',
            },
            restrictions: {
                maxDate: today,
                minDate,
            },
        };
        const startDatePicker = new tempusDominus.TempusDominus(document.getElementById('search-start-date'), {
            ...dateOptions,
            container: document.getElementById('start-date-container'),
        });
        const endDatePicker = new tempusDominus.TempusDominus(document.getElementById('search-end-date'), {
            ...dateOptions,
            container: document.getElementById('end-date-container'),
        });

        startDatePicker.dates.setValue(startDatePicker.dates.parseInput(minDate));
        endDatePicker.dates.setValue(endDatePicker.dates.parseInput(today));

        $('#search-start-date').on('change', () => {
            studentProgressTable.bootstrapTable('refresh');
        });
        $('#search-end-date').on('change', () => {
            studentProgressTable.bootstrapTable('refresh');
        });

        $('#export-student-progress-report').on('click', (event) => {
            event.preventDefault();
            const opts = studentProgressTable.bootstrapTable('getOptions');
            const startDate = document.getElementById('search-start-date').value;
            const endDate = document.getElementById('search-end-date').value;

            const exportParams = {
                offset: 0,
                limit: 9999999,
                sort: opts.sortName,
                order: opts.sortOrder,
                date_range_from: startDate,
                date_range_to: endDate,
            };

            const queryString = $.param(exportParams);
            window.open(`${exportUrl}?${queryString}`, '_blank');
        });
    };

    const progressBars = [];

    const setupProgressBars = function () {
        const progressIndicatorContainers = document.querySelectorAll('.progress-indicator');
        if (progressIndicatorContainers.length) {
            progressIndicatorContainers.forEach((indicator) => {
                const progress = $(indicator).data('progress');
                const userId = $(indicator).data('user-id');
                const barLine = $(indicator).attr('id');

                const bar = new ProgressBar.Line(`#${barLine}`, {
                    strokeWidth: 3,
                    easing: 'easeInOut',
                    duration: 1400,
                    color: '#000',
                    trailColor: '#eee',
                    trailWidth: 3,
                    svgStyle: { width: '100%', height: '100%' },
                    from: { color: '#CDCD00' },
                    to: { color: '#1A9D5A' },
                    step: (state, progressBar) => {
                        progressBar.path.setAttribute('stroke', state.color);
                        progressBar.setText(`${Math.round(progressBar.value() * 100)} %`);
                    },
                });
                bar.animate(progress / 100); // Value from 0.0 to 1.0
                progressBars[userId] = bar;
            });
        }
    };

    const initBootstrapTable = () => {
        const lessonId = studentProgressTable.data('lesson-id');
        const hasWrittenResponse = studentProgressTable.data('has-written-response');

        const columns = [
            {
                title: 'Subtitle',
                field: 'subtitle',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Completion Type',
                field: 'completion_type',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Assigned By',
                field: 'assigned_by',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Assigned To',
                field: 'assigned_to',
                align: 'left',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    const userViewUrl = studentProgressTable.data('user-view-url').replace(':user_id', row.user_id);
                    const name = `${value}<br/>(${row.username})`.trim();

                    return `<a href="${userViewUrl}">${name}</a>`;
                },
            },
            {
                title: 'Written<br>Responses',
                field: 'written_responses',
                align: 'center',
                valign: 'middle',
                sortable: false,
                visible: +hasWrittenResponse === 1,
                formatter(value, row) {
                    if (value.length === 0) {
                        return '';
                    }

                    return `
                        <a href="#"
                            data-toggle="modal"
                            data-target="#written-response-modal-${row.user_lesson_id}"
                            >
                            <i class="fa fa-comment" aria-hidden="true"></i>
                        </a>
                        <div class="modal demo-modals fade" id="written-response-modal-${row.user_lesson_id}"
                            tabindex="-1" role="dialog" aria-labelledby="personalized-modal">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <a type="button" class="close" data-dismiss="modal"
                                            aria-label="Close"><span aria-hidden="true">&times;</span></a>
                                        <div class="modal-title">
                                            Written Responses
                                        </div>
                                    </div>
                                    <div class="modal-body">
                                        <!-- form -->
                                        <div class="row">
                                            ${value.map(
                        (response) => `
                                                    <div class="written-response">
                                                        ${response.instructions ? `<h2>${response.instructions}</h2>` : ''}
                                                        ${response.question_text ? `<h3>${response.question_text}</h3>` : ''}
                                                        <p>${response.response}</p>
                                                    </div>
                                                `,
                    )}
                                        </div>
                                        <!-- end form -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    `;
                },
            },
            {
                title: 'Interest',
                field: 'interest',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                formatter(value) {
                    let interestEmoji = '';
                    if (value === 'positive') {
                        interestEmoji = 'fa-face-smile text-success';
                    } else if (value === 'neutral') {
                        interestEmoji = 'fa-face-meh';
                    } else if (value === 'negative') {
                        interestEmoji = 'fa-face-frown text-danger';
                    }

                    return `${value} <i class="fa-regular ${interestEmoji}" aria-hidden="true" />`;
                },
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Assigned',
                field: 'date_assigned',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    const assignmentUrl = studentProgressTable
                        .data('assignment-view-url')
                        .replace(':lesson_id', row.lesson_id)
                        .replace(':assignment_id', row.assignment_id);

                    return `<a href="${assignmentUrl}">${new Date(value).toLocaleDateString('en-us', 'L')}</a>`;
                },
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Start',
                field: 'date_started',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter: (value) => (value ? new Date(value).toLocaleDateString('en-US', { timeZone: 'UTC' }) : '-'),
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Completed',
                field: 'date_completed',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter: (value) => (value ? new Date(value).toLocaleDateString('en-us', 'L') : '-'),
            },
            {
                title: 'Progress',
                field: 'progress',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value, row) {
                    return `
                        <div
                            class="progress-indicator hidden-print"
                            id="student-progress-${row.user_id}-${row.assignment_id}-${row.lesson_id}"
                            data-progress="${value}"
                            data-user-id="${row.user_id}"
                        ></div>
                        <span class="visible-print">${value}%</span>
                    `;
                },
            },
        ];

        studentProgressTable.bootstrapTable({
            formatNoMatches: () => 'No activity to show',
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'activity_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: `/lessons/${lessonId}/json/`,
            pageSize: 25,
            queryParamsType: '',
            queryParams(params) {
                const myParams = { ...params };
                const startDate = document.getElementById('search-start-date').value;
                const endDate = document.getElementById('search-end-date').value;

                myParams.search_term = params.searchText;
                myParams.group_ids = [...document.querySelectorAll('#user-groups option:checked')].map((group) => group.value);
                myParams.date_range_from = startDate;
                myParams.date_range_to = endDate;

                return myParams;
            },
            columns,
            responseHandler: (res) => ({ total: res.meta.total, rows: res.data }),
            onLoadSuccess: setupProgressBars,
            rowStyle: (row) => {
                let classes = '';
                if (row.progress < 33.3333) {
                    classes += 'danger ';
                } else if (row.progress < 66.6666) {
                    classes += 'warning ';
                } else if (row.progress < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    return self;
}(Postlogin || {}));
